import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Footer from '../Footer/FooterContainer';
import RecommendedTargetAmountChart from '../../RecommendedTargetAmountChart/RecommendedTargetAmountChartContainer';
import FinancialPlanHeader from '../FinancialPlanHeaderView';
import ActionStepsV2 from '../ActionStepsV2/ActionStepsV2Container';
import Explanations from '../Explanations/ExplanationsContainer';
import { ASSUMPTIONS, OVERVIEW } from '../Explanations/ExplanationsConst';
import AssumptionsSectionView from '../Components/AssumptionsTable';
import homePurchaseAssumptionsLabelMap from './HomePurchaseAssumptions';
import { HomePurchaseChartModal } from './HomePurchaseChartModal';
import GeneralAssumptionsView from '../GeneralAssumptions';
import { Button } from '../../CommonComponents/OPL/Button/Button';
import { Tasks } from '../../FinancialPlanOPL/Goals/components/Tasks/Tasks';

export default class HomePurchaseView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showChartModal: false,
    };

    this.handleChartButtonClick = this.handleChartButtonClick.bind(this);
  }

  handleChartButtonClick() {
    const { showChartModal } = this.state;

    this.setState({
      showChartModal: !showChartModal,
    });
  }

  render() {
    const {
      clientId,
      homePurchaseGoal,
      fpId,
      data,
      isPrint,
      chartDataPrint,
      showCalibration,
      isCurrentPlan,
      selectedSection,
      assumptionsValues,
    } = this.props;

    if (!homePurchaseGoal) {
      return null;
    }

    const { showChartModal } = this.state;

    const { DesiredPurchaseYear, GoalCharts } = homePurchaseGoal;
    const chartSeries = GoalCharts[0].Data.Series;

    return (
      <div className="NewFinancialPlan_homePurchase">
        {showChartModal && (
          <HomePurchaseChartModal
            onClose={this.handleChartButtonClick}
            desiredPurchaseYear={DesiredPurchaseYear}
            chartSeries={chartSeries}
          />
        )}
        <div
          className={`NewFinancialPlan_header
            ${!showCalibration ? ' hide-calibration-button' : ''}
          `}
        >
          <FinancialPlanHeader
            {...this.props}
            hideOldDescription={false}
            hideTrackIndicator={selectedSection === ASSUMPTIONS && isPrint}
          />
        </div>
        <section className="calibration" />
        {!isPrint && <Explanations clientId={clientId} />}
        {selectedSection === OVERVIEW && (
          <section className="chart">
            <div
              role="img"
              aria-label="Chart showing how much expenses are covered for down payment. Extended description is below."
            >
              <RecommendedTargetAmountChart
                isPrint={isPrint}
                chartDataPrint={chartDataPrint}
                title={isCurrentPlan ? 'Savings Schedule' : 'Recommended Savings Schedule'}
                hasLegend
                clientId={clientId}
                data={homePurchaseGoal}
                fpId={fpId}
              />
            </div>
            <Button variant="subtleActive" onClick={this.handleChartButtonClick}>
              Chart Description
            </Button>
          </section>
        )}
        {selectedSection === ASSUMPTIONS && !isPrint && (
          <div className="assumptions-container">
            <AssumptionsSectionView
              title="Home Purchase Goal Assumptions"
              valuesList={assumptionsValues}
              labelList={homePurchaseAssumptionsLabelMap}
            />
            <br />
            <GeneralAssumptionsView clientId={clientId} />
          </div>
        )}

        {!isPrint && selectedSection !== ASSUMPTIONS && <Tasks />}

        {isPrint && selectedSection !== ASSUMPTIONS && (
          <ActionStepsV2 clientId={clientId} fpId={fpId} goalId={homePurchaseGoal.GoalId} />
        )}

        {!isPrint && <Footer data={data} clientId={clientId} fpId={fpId} />}
      </div>
    );
  }
}

HomePurchaseView.defaultProps = {
  chartDataPrint: null,
  isPrint: false,
};

HomePurchaseView.propTypes = {
  clientId: PropTypes.string.isRequired,
  fpId: PropTypes.string.isRequired,
  isPrint: PropTypes.bool,
  homePurchaseGoal: PropTypes.shape().isRequired,
  data: PropTypes.shape().isRequired,
  chartDataPrint: PropTypes.shape(),
  showCalibration: PropTypes.bool.isRequired,
  isCurrentPlan: PropTypes.bool.isRequired,
  selectedSection: PropTypes.string.isRequired,
  assumptionsValues: PropTypes.shape().isRequired,
};
